"use client";
import React, { useEffect, useState } from "react";
import HeroBanner from "../home-six/HeroBanner";
import FooterFive from "@/layouts/footers/FooterFive";
import axiosInstance from "@/service/axiosInstance";
import Loader from "@/components/Loader/Loader";
import {
  getSortedSectionsWRTType,
  getSortedSectionsWRTpage,
  getSortedWRTpage,
} from "@/utils/utils";
import TermAndCondition from "@/components/term-condition";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logout } from "@/redux/features/authSlice";
import { APP_NAME, ToastOptions, CommonConstant } from "@/utils/enum";

const Page = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [bannerData, setbannerData] = useState([]);
  const [footerData, setFooterData] = useState([[]]);
  const [tncDAta, setTncDAta] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);

  function getSortedSections(data: any, section: any) {
    return data
      .filter((item: any) => item.attributes.Section === section)
      .sort((a: any, b: any) => a.attributes.Sequence - b.attributes.Sequence)
      .map((item: any) => ({
        id: item.id,
        scetion: item.attributes.Section,
        page: item.attributes.Page,
        type: item.attributes.Type,
        Title: item.attributes.Title,
        URL: item.attributes.URL,
        content: item.attributes.Content,
        Image_Path: item.attributes.Image_Path,
        sequence: item.attributes.Sequence,
        academicYear: item.attributes.ac_academic_year.data?.attributes.name,
      }));
  }

  const getData = async (app_name: string) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const resp: any = await axiosInstance.get(
        `/homePage?app_name=${app_name}`,
        {},
      );
      if (token) {
        if (
          resp?.isAuthorized?.status == 401 ||
          resp?.isAuthorized?.message == "Token has expired"
        ) {
          console.log("Token has expired!");
          toast.error("Session expired. Please log in again", ToastOptions);
          localStorage.removeItem("token");
          dispatch(logout());

          // router.push(`/login?redirect="true"`);

          // return;
        }
      }

      const BannerData = getSortedSections(resp?.data?.data, "Banner");

      setbannerData(BannerData);
      const footerData1 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 1",
      );
      const tncData = getSortedWRTpage(resp?.data?.data, CommonConstant.TNC);

      setTncDAta(tncData);

      const footerData2 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 2",
      );

      const footerData3 = getSortedSectionsWRTType(
        resp?.data?.data,
        "Footer",
        "Link 3",
      );
      const socialMediaData = getSortedSectionsWRTpage(
        resp?.data?.data,
        "Social Media",
        "Home Page",
      );
      setSocialMedia(socialMediaData);

      setFooterData([footerData1, footerData2, footerData3]);

      setData(resp?.data?.data);
      setLoading(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const app_name: string = process.env.NEXT_PUBLIC_APP_NAME || "";

  useEffect(() => {
    switch (app_name) {
      case APP_NAME.VIBGYOR_VIVA:
      case APP_NAME.VIBGYOR_ONE:
        getData(app_name);
        break;

      default:
        break;
    }
  }, []);

  return (
    <>
      {loading && <Loader />}
      {/* <HeaderOne style={true} /> */}
      {[APP_NAME.VIBGYOR_VIVA, APP_NAME.VIBGYOR_ONE].includes(app_name) && (
        <>
          <HeroBanner bannerData={bannerData} />
          <TermAndCondition data={tncDAta} />
          <FooterFive data={footerData} socialMedia={socialMedia} />
        </>
      )}
    </>
  );
};

export default Page;
